import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { panditTtkSchema } from '../schemas';
import axios from "axios";
import ThinksToKnowStatus from './ThinksToKnowStatus';

const PanditTTK = () => {
    const workingSinceOption = checkboxData.workSinceOption;
    const languageOption = checkboxData.languageOption;
    const serviceOfferedPanditOption = checkboxData.serviceOfferedPandit;
    const areaOfWorkingOption = checkboxData.areaOfWorking;
    const samagriOption = checkboxData.samagriOption
    const { user, language, token } = useUserAuth();
    const merchant_id = user.uid;
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const [merchant, setMerchant] = useState({});


    const [data, setData] = useState({
        WeddingPrice: '',
        kundaliMatchPrice: '',
        areaOfWorking: [],
        workingSince: [],
        language: [],
        servicePandit: [],
        samagri: []
    })

    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            // const details = rawDetails ? JSON.parse(rawDetails) : null;
            if (details) {
                setMerchant(details);
                // formik.setValues(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };

    useEffect(() => {
        getSingleDocumentHandler()
    }, [merchant_id, token])

    const formik = useFormik({
        initialValues: {
            WeddingPrice: merchant?.WeddingPrice || '',
            kundaliMatchPrice: merchant?.kundaliMatchPrice || '',
            language: merchant?.language || [],
            workingSince: merchant?.workingSince || [],
            areaOfWorking: merchant?.areaOfWorking || [],
            samagri: merchant?.samagri || [],
            servicePandit: merchant?.servicePandit || [],
        },
        validationSchema: panditTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: { ...values },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });
    const [ttkEditMode, setTtkEditMode] = useState(false)
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header  text-white text-center ' style={{ backgroundColor: '#085f9a' }}>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant.thingsToKnow && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Area of Services</th>
                                                            <th style={{ width: '25%' }}>Languages You Prefer Rituals In?</th>
                                                            <th>Pooja/Ceremonies You Offer?</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.thingsToKnow.workingSince?.map((item, index) => {
                                                                    return <p key={index}>{item.value}</p>
                                                                })
                                                            }</td>
                                                            <td>{
                                                                merchant.thingsToKnow.areaOfWorking
                                                                    ?.map((item, index) => {
                                                                        return <span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>
                                                                    })
                                                            }</td>
                                                            <td>{
                                                                merchant.thingsToKnow.language?.map((item, index) => {
                                                                    return (
                                                                        <>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span key={index}>{item.value} </span>
                                                                        </>
                                                                    )
                                                                })
                                                            }</td>
                                                            <td>{
                                                                merchant.thingsToKnow.servicePandit
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span key={index}>{item.value} </span>
                                                                            </>
                                                                        )
                                                                    })
                                                            }</td>


                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>Samagri</th>
                                                            <th>Starting Price of Wedding Services</th>

                                                            <th>Pricing for Kundli Matching </th>
                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.thingsToKnow.samagri
                                                                    ?.map((item, index) => {
                                                                        return <p key={index}>{item.value}</p>
                                                                    })
                                                            }</td>
                                                            <td>&#8377;{merchant.thingsToKnow.WeddingPrice}</td>


                                                            <td> &#8377;{merchant.thingsToKnow.kundaliMatchPrice}</td>
                                                        </tr>


                                                    </tbody>
                                                </table>

                                            </div>
                                        </>
                                    )
                                }
                                <center >
                                    <button className='btn text-white mb-2' style={{ backgroundColor: '#085f9a' }} onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant.thingsToKnow ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>

                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Area of Services <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={areaOfWorkingOption}
                                                            selected
                                                            value={formik.values.areaOfWorking}
                                                            onChange={(areaOfWorking) => formik.setFieldValue('areaOfWorking', areaOfWorking)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.areaOfWorking && formik.errors.areaOfWorking ? (
                                                            <div className="text-danger">{formik.errors.areaOfWorking}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Languages You Prefer Rituals In?<span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={languageOption}
                                                            selected
                                                            value={formik.values.language}
                                                            onChange={(language) => formik.setFieldValue('language', language)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.language && formik.errors.language ? (
                                                            <div className="text-danger">{formik.errors.language}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Pooja/Ceremonies You Offer ?<span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={serviceOfferedPanditOption}
                                                            selected
                                                            value={formik.values.servicePandit}
                                                            onChange={(servicePandit) => formik.setFieldValue('servicePandit', servicePandit)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.servicePandit && formik.errors.servicePandit ? (
                                                            <div className="text-danger">{formik.errors.servicePandit}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Samagri  <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={samagriOption}
                                                            selected
                                                            value={formik.values.samagri}
                                                            onChange={(samagri) => formik.setFieldValue('samagri', samagri)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.samagri && formik.errors.samagri ? (
                                                            <div className="text-danger">{formik.errors.samagri}</div>
                                                        ) : null}
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Starting Price of Wedding Services <span className='text-danger'>*</span></label>
                                                        <input
                                                            type='number'
                                                            placeholder='Starting Price of Wedding Services'
                                                            name="WeddingPrice"
                                                            className='form-control'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.WeddingPrice}
                                                        />
                                                        {formik.touched.WeddingPrice && formik.errors.WeddingPrice ? (
                                                            <div className="text-danger">{formik.errors.WeddingPrice}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Pricing for Kundli Matching<span className='text-danger'>*</span></label>
                                                        <input
                                                            type='number'
                                                            placeholder='Pricing for Kundli Matching Per Person'
                                                            name="kundaliMatchPrice"
                                                            className='form-control'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.kundaliMatchPrice}
                                                        />
                                                        {formik.touched.kundaliMatchPrice && formik.errors.kundaliMatchPrice ? (
                                                            <div className="text-danger">{formik.errors.kundaliMatchPrice}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-group text-center'>
                                                <button className='btn text-white' type='submit' style={{ backgroundColor: '#085f9a' }} >{ttkEditMode ? 'Save Changes' : 'Submit'}</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PanditTTK